import { apiRequest } from '../http.js'

export const earningsApi = {
getAll: async (campaignId = null, options = {}) => {
      const qs = new URLSearchParams()
      if (campaignId) qs.set('campaignId', campaignId)
      const suffix = qs.toString() ? `?${qs.toString()}` : ''
      const data = await apiRequest(`/earnings${suffix}`, options)
      return data.earnings || []
    },
}
